import cloneDeep from 'lodash/cloneDeep'
import { ref, toRaw } from 'vue'
import { useStore } from 'vuex'

import { searchUser, searchUserFromAll } from '@/api/user'
import debounce from 'lodash/debounce'

export default function useSearchUser (type) {
  const store = useStore()
  const isLoading = ref(false)
  const searchValue = ref('')
  const frequentContacts = cloneDeep(toRaw(store.getters.frequentContacts))
  const users = ref(frequentContacts)
  const isFrequentContactsVisible = ref(true)
  const searchFn = type === 'ALL' ? searchUserFromAll : searchUser
  const loadUsers = debounce(keyword => {
    searchFn(keyword)
      .then(usersRaw => {
        // 如果在搜索的过程中用户又输入了新的关键词，则不显示原来的搜索结果
        if (keyword !== searchValue.value) {
          return
        }
        isFrequentContactsVisible.value = false
        users.value = usersRaw
        isLoading.value = false
      })
  }, 500)

  function search (keyword) {
    searchValue.value = keyword
    isLoading.value = !!keyword
    users.value = []
    if (!keyword) {
      isFrequentContactsVisible.value = true
      users.value = frequentContacts
      return
    }

    loadUsers(keyword)
  }

  return {
    isLoading,
    searchValue,
    users,
    search,
    isFrequentContactsVisible
  }
}
